import IngeekJSAPI from "./ingeek-jsapi";

export default IngeekJSAPI;

